import { useSelector } from 'react-redux'
import { getCountry } from 'ggx-service/locale/country.service'

export const getIsDPMonthlySettlementEnabled = state =>
  state.payment.isDPMonthlySettlementEnabled

export const useIsDPMonthlySettlementEnabled = () => {
  return useSelector(state => state.payment.isDPMonthlySettlementEnabled)
}

export const getIsTPMonthlySettlementEnabled = state =>
  state.payment.isTPMonthlySettlementEnabled

export const useIsTPMonthlySettlementEnabled = () => {
  return useSelector(state => state.payment.isTPMonthlySettlementEnabled)
}

export const isAbleToPayByCreditCard = state => {
  return (
    getCountry() === 'HK' &&
    (state.payment?.availablePaymentMethods?.includes('credit_card') ||
      state.payment?.availableDpPaymentMethods?.includes('credit_card'))
  )
}
